import { render, staticRenderFns } from "./MiniTypeTable.vue?vue&type=template&id=437f563d&scoped=true&"
import script from "./MiniTypeTable.vue?vue&type=script&lang=js&"
export * from "./MiniTypeTable.vue?vue&type=script&lang=js&"
import style0 from "./MiniTypeTable.vue?vue&type=style&index=0&id=437f563d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437f563d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSystemBar } from 'vuetify/lib/components/VSystemBar';
installComponents(component, {VIcon,VSimpleTable,VSpacer,VSystemBar})
